import { FC } from 'react'
import classNames from 'classnames'
import { getShortURL, sanitizeUrl } from '@/utils'
import ArrowUpRightSvg from '@/public/images/common/arrow-up-right-purple_v2.svg'
import styles from './index.module.scss'

type Props = {
  isLink?: boolean
  href?: string
  name: string
  value?: string
  isMultiline?: boolean
}

export const CompanyStatusListItem: FC<Props> = ({
  isLink = false,
  href = '/',
  name,
  value = '',
  isMultiline = false,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.name}>{name}</div>
      <div
        className={classNames(styles.value, {
          [styles.wrap]: isMultiline,
        })}
      >
        {isLink ? (
          <a className={styles.link} href={sanitizeUrl(href)} target='_blank' rel='noreferrer'>
            {getShortURL(value)}
            <ArrowUpRightSvg viewBox='0 0 20 20' />
          </a>
        ) : (
          <>{value}</>
        )}
      </div>
    </div>
  )
}
